import { FormInput } from '@systemeio/ui'
import React from 'react'
import { isClient } from 'shared/components/screen-height-div'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface FormEditSubdomainInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error: string
  onChangeValue: (value: string) => void
}
const parseValue = (value: string) =>
  isClient() ? value.split(`.${window.location.host}`) : undefined

const FormEditSubdomainInput = ({ error, value, onChangeValue }: FormEditSubdomainInputProps) => {
  const { t } = useLocoTranslation()
  return (
    <FormInput
      label={t('global.subdomain')}
      value={parseValue(value as string)?.[0]}
      onChange={e => onChangeValue(e.target.value)}
      spellCheck={false}
      error={error}
      addonBefore={`${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://`}
      addonAfter={isClient() ? `.${window.location.host}` : undefined}
    />
  )
}

export default FormEditSubdomainInput
